import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { PIC } from '../Internals';
/* default parmConverter to decodeInput parms */
export function stringDecoder(iVal) {
    if (iVal) {
        try {
            let tmp = decodeURIComponent(iVal);
            return tmp == '<null>' ? null : tmp;
        }
        catch (e) {
            //means it is not url-encoded (or wrongly)
            //ideally unneeded, but... for now return the value as-is
            //decodeURIComponent also expects it to be utf-8?, might be erroneous
            if (e instanceof URIError) {
                return iVal == '<null>' ? null : iVal;
            }
            return null;
        }
    }
    else
        return null;
}
export function labelDecoder(iVal) {
    if (iVal) {
        try {
            let tmp = decodeURIComponent(iVal);
            tmp == '<null>' ? null : tmp;
            if (tmp.match(/<b>|<i>|<font>/)) {
                return unsafeHTML(`${tmp}`);
            }
            return tmp;
        }
        catch (e) {
            if (e instanceof URIError) {
                return iVal == '<null>' ? null : iVal;
            }
            return null;
        }
    }
    else
        return null;
}
export function stringDecoderLC(iVal) {
    if (iVal) {
        try {
            let tmp = decodeURIComponent(iVal);
            return tmp == '<null>' ? null : tmp.toLowerCase();
        }
        catch (e) {
            if (e instanceof URIError) {
                return iVal == '<null>' ? null : iVal;
            }
            return null;
        }
    }
    else
        return null;
}
export function numberDecoder(iVal) {
    let tmp = stringDecoder(iVal);
    if (tmp) {
        return Number(tmp); //... should probably be Number(tmp)
    }
    else
        return null;
}
/**
 * Convenience method when using enums.
 * Pitfalls include: For number enums, 0,1,2... is also valid values.
 * Use it like converter: enumConverter(MyEnum, MyEnum.DefaultValue)
 * @param iEnum Enum type to use, fx SelectionMode
 * @param defaultValue Enum value to default to if converted value is not in set
 * @returns
 */
export const enumConverter = (iEnum, defaultValue) => {
    return (value, type) => {
        if (value === null)
            return defaultValue;
        if (Object.values(iEnum).includes(value))
            return value;
        return defaultValue;
    };
};
export function json2Validate(iVal) {
    let res;
    if (iVal) {
        try {
            if (iVal.includes("'")) {
                iVal = iVal.replace(new RegExp("'", 'g'), '"');
            }
            res = JSON.parse(iVal);
            return res;
        }
        catch (_a) {
            console.log(iVal);
            return undefined;
        }
    }
    else
        return undefined;
}
export function arrayDecoder(iVal) {
    let resArr = [];
    if (iVal) {
        if (iVal.includes("'")) {
            iVal = iVal.replace(new RegExp("'", 'g'), '"');
        }
        resArr = JSON.parse(decodeURIComponent(iVal), function (key, value) {
            //try to parse date values
            if (typeof value === 'string' && (key.toLowerCase().includes('date'))) {
                try {
                    return new Date(value).setHours(0, 0, 0, 0);
                }
                catch (error) {
                    return value;
                }
            }
            return value;
        });
        return resArr;
    }
    else
        return null;
}
export function objectDecoder(iVal) {
    if (iVal) {
        if (iVal.includes("'")) {
            iVal = iVal.replace(new RegExp("'", 'g'), '"');
        }
        return JSON.parse(decodeURIComponent(iVal));
    }
    else
        return null;
}
export function booleanDecoder(iVal) {
    let tmp;
    if (iVal) {
        tmp = decodeURIComponent(iVal);
        return tmp == 'true';
    }
    return false;
}
export function dateDecoder(iVal) {
    let tmp = stringDecoder(iVal);
    let res = null;
    if (tmp) {
        if (!isNaN(Date.parse(tmp)))
            res = new Date(tmp);
    }
    return res;
}
export function stringDateDecoder(iVal) {
    let tmp = stringDecoder(iVal);
    let res = null;
    if (tmp) {
        if (tmp.includes('-'))
            res = tmp;
        else
            res = tmp.substring(0, 4) + '-' + tmp.substring(4, 6) + '-' + tmp.substring(6);
    }
    return res;
}
export function chunkDecoder(iElm) {
    let res = '';
    if (iElm.hasAttribute('chunkno')) {
        for (let i = 1; i < parseInt(iElm.getAttribute('chunkno')) + 1; i++) {
            res += stringDecoder(iElm.getAttribute('valuechunk' + i));
        }
    }
    return res;
}
export function base64Decoder(iVal) {
    let res = '';
    try {
        res = atob(iVal);
    }
    catch (_a) { }
    return res;
}
export function base64DecoderJSON(iVal) {
    let res = {};
    try {
        let decodedStr = base64Decoder(iVal);
        if (decodedStr)
            res = JSON.parse(decodedStr);
    }
    catch (_a) { }
    return res;
}
/*TODO: Enums for options */
export function toUserLocaleInt(iNumber) {
    return toUserLocaleString(PIC.getInstance.userConfig.numberLang, iNumber, { style: 'decimal', maximumFractionDigits: 0 });
}
/**
 * Get a float/decimal string representation of a number using the Intl.NumberFormatOptions parameters, this method defaults to the min/max set by userConfig
 */
export function toUserLocaleFloat(iNumber, options) {
    if (typeof options === 'undefined')
        options = {};
    if (typeof options.minimumFractionDigits === 'undefined')
        options.minimumFractionDigits = PIC.getInstance.userConfig.minMaxDigits.min;
    if (typeof options.maximumFractionDigits === 'undefined')
        options.maximumFractionDigits = PIC.getInstance.userConfig.minMaxDigits.max;
    options.style = 'decimal';
    return toUserLocaleString(PIC.getInstance.userConfig.numberLang, iNumber, options);
}
export function toUserLocaleNumber(iNumber) {
    return toUserLocaleString(PIC.getInstance.userConfig.numberLang, iNumber, { style: 'decimal', maximumFractionDigits: 2 });
}
export function toUserLocaleDate(iDate) {
    return toUserLocaleString(PIC.getInstance.userConfig.dateLang, iDate, PIC.getInstance.userConfig.dateOptions);
}
export function toUserLocaleTime(iTime) {
    return iTime.toLocaleTimeString(PIC.getInstance.userConfig.dateLang, PIC.getInstance.userConfig.timeOptions);
}
export function toUserLocaleDateTime(iDateTime) {
    return toUserLocaleString(PIC.getInstance.userConfig.dateLang, iDateTime, PIC.getInstance.userConfig.dateTimeOptions);
}
export function toUserLocaleCurrency(iValue, iCurrency) {
    iCurrency = iCurrency ? iCurrency : PIC.getInstance.userConfig.currency;
    return toUserLocaleString(PIC.getInstance.userConfig.currencyLang, iValue, { style: 'currency', currency: iCurrency });
}
export function toUserLocaleString(iLang, iData, iOpt) {
    iLang = iLang ? iLang : PIC.getInstance.userConfig.userLang;
    if (iData instanceof Date) {
        return iData.toLocaleDateString();
    }
    else if (typeof iData === 'string' || typeof iData === 'number') {
        return iData.toLocaleString(iLang, iOpt);
    }
    else
        return '';
}
export function parseLocaleNumber(value, locale) {
    var _a, _b, _c, _d;
    const example = new Intl.NumberFormat(locale).formatToParts(12345.6);
    const group = (_b = (_a = example.find(p => p.type === "group")) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : ",";
    const decimal = (_d = (_c = example.find(p => p.type === "decimal")) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : ".";
    // Escape for RegExp
    const esc = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const normalized = value
        .trim()
        .replace(/[\s\u00A0\u202F]/g, "") // remove normal/NBSP/narrow-NBSP spaces
        .replace(new RegExp(esc(group), "g"), "") // remove thousands separators
        .replace(new RegExp(esc(decimal)), "."); // decimal -> dot
    return Number(normalized);
}
//# sourceMappingURL=PICConverters.js.map